import { render, staticRenderFns } from "./ConsultaVoluntario.vue?vue&type=template&id=66cca6b4"
import script from "./ConsultaVoluntario.vue?vue&type=script&lang=js"
export * from "./ConsultaVoluntario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports